import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROLE_ROUTES } from '../contexts/AuthContext';

/**
 * ProtectedRoute
 * - allowedRoles: array of roles that can access this route (empty = any authenticated user)
 * - requireEmailVerification: if true, redirect to /verify-email if not verified
 */
export default function ProtectedRoute({ children, allowedRoles = [], requireEmailVerification = true }) {
  const { user, loading, isEmailVerified, userRole, profileLoading } = useAuth()
  const location = useLocation()

  if (loading || profileLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <svg className="animate-spin h-10 w-10 text-teal-400" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <p className="text-slate-400 text-sm font-body">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login-page" state={{ from: location }} replace />
  }

  if (requireEmailVerification && !isEmailVerified) {
    return <Navigate to="/verify-email" state={{ email: user?.email }} replace />
  }

  if (allowedRoles?.length > 0 && userRole && !allowedRoles?.includes(userRole)) {
    // Redirect to their correct portal
    const correctRoute = ROLE_ROUTES?.[userRole] || '/login-page'
    return <Navigate to={correctRoute} replace />
  }

  return children
}
